module.exports = __webpack_public_path__ + "images/album_500.7d4c7506560849c0a606b93e9f06de71.png";